import TextStats from './TextStats';
export default TextStats;